// 需要登录的接口列表，待补充
export const LOGIN_REQUIRED_ENDPOINTS = [/\/api\/resources\/v1\/images\/optimize/];

// 消耗算力的接口列表
export const CREDITS_CONSUMING_ENDPOINTS = [
	/\/api\/resources\/v1\/images\/optimize/, //精绘
	/\/api\/resources\/v1\/images\/generate/, //消费侧生成
	// /\/api\/resources\/v1\/images\/test/, //构建侧生成
];

//消耗算力的接口列表(精绘)
export const Optimize_ENDPOINTS = [
	/\/api\/resources\/v1\/images\/optimize/,
	/\/api\/resources\/v1\/images\/test\/optimize/,
];

export const I18N_ENDPOINTS = [
	'api/community/v1/publications/recommends/v2',
	'api/resources/v1/images',
	'api/community/v1/incentives/rank-table',
	'api/community/v1/publications/applications',
	'api/resources/v1/topics/pubs',
	/api\/resources\/v1\/topics\/[\w\d]+\/pub-apps/,
	/api\/resources\/v1\/topics\/info\/[\w\d]+/,
	'api/community/v1/incentives/rank-table',
	'api/community/v1/publications/',
	/api\/community\/v1\/publications\/\d+\/images/,
	/api\/resources\/v1\/images\/[\w\d]+/,
	/api\/resources\/v1\/images\/\d+\/recommend/,
	/api\/resources\/(v1|v2)\/applications\/home/,
	/api\/resources\/v1\/applications\/pins/,
	/api\/community\/v1\/publications\/favorite/,
	/api\/community\/v1\/publications\/favorite/,
	'api/community/v1/publications/labels',
	'api/community/v1/search',
	'api/resources/v2/product',
	/api\/resources\/v1\/canvas-templates\/labels/,
	/api\/resources\/v1\/canvas-templates/,
	'api/resources/v1/matrix',
	'/api/resources/v1/posts/list',
	'/api/resources/v1/posts/info',
	/api\/resources\/v1\/posts\/[\w\d]+/,
	'/api/resources/v1/subject/list',
	/api\/resources\/v1\/subject\/info\/\w+/,
	/api\/resources\/v1\/subject\/info\/\w+\/post/,
	/api\/resources\/v1\/subject\/info\/\w+\/config-apps/,
	/api\/resources\/v1\/subject\/\w+\/post/,
	'/api/resources/v1/subject/imageIds',
	'api/resources/v1/preference',
	'/api/resources/v2/preference/list',
	'api/resources/v1/control_net',
	'/api/community/v2/search',
	'/api/interaction/v1/message/list',
	'/api/resources/v1/task/task-pend/list',
	/api\/community\/v1\/translation\/\w+\/\w+/,
	'/api/resources/v1/capability/collection/list',
	/api\/resources\/v1\/capability\/collection\/([\w\d]+)\/template\/list/,
	/api\/resources\/v1\/capability\/collection\/([\w\d]+)\/app\/list/,
	'/api/resources/v1/user-scene',
	'/api/resources/v1/capability/banners/list',
	'/api/resources/v1/template',
	'api/resources/v1/applications',
	'/api/ai-hub-server/conversation',
	'/api/ai-hub-server/chatbot',
	'/api/ai-hub-server/conversation/guide',
	'/api/ai-hub-server/conversation/history',
	'/api/ai-hub-server/chatbot-user-relation',
	'/api/ai-hub-server/chatbot-user-info',
	'/api/resources/v1/action-template/list',
	'/api/resources/v1/infinite-talk-example',
];

export const GENERATE_ENDPOINTS = [
	'/api/resources/v1/images/generate',
	'/api/resources/v1/images/test',
	'/api/ai-hub-server/conversation/images/generate',
];

// 包含生图和精绘的所有接口
export const CREATE_ENDPOINTS = [
	'/api/resources/v1/images/generate',
	'/api/resources/v1/images/test',
	'/api/ai-hub-server/conversation/images/generate',
	'/api/resources/v1/images/optimize',
	'/api/resources/v1/images/test/optimize',
];
